import { Link as RouterLink } from 'react-router-dom';
import { Link } from '@mui/material';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';

export const ExternalLinkWithIcon = ({ path, text }) => {
  return (
    <Link
      component={RouterLink}
      to={path}
      target='_blank'
      underline='hover'
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        color: 'inherit',
      }}
    >
      {text}
      <OpenInNewIcon sx={{ fontSize: 16, ml: 0.5 }} />
    </Link>
  );
};
